<template>
  <div>
    <Filtro :vistoria="false" @filtro="makeFiltro"></Filtro>
    <div class="vx-row">
      <div class="vx-col w-full md:w-2/3 mb-base">
        <vs-card v-if="carregado == true">
          <h3>
            Segurados {{ formataData2(this.objSend.dataInicial) }} -
            {{ formataData2(this.objSend.dataFinal) }}
          </h3>
          <vue-apex-charts
            type="area"
            height="350"
            :options="lineAreaChartSpline.chartOptions"
            :series="lineAreaChartSpline.series"
          ></vue-apex-charts>
        </vs-card>
      </div>
      <div class="vx-col w-full md:w-1/3 mb-base">
        <vx-card title="Taxa de Crescimento Segurados">
          <template slot="actions">
            <feather-icon
              icon="HelpCircleIcon"
              svgClasses="w-6 h-6 text-grey"
            ></feather-icon>
          </template>

          <!-- CHART -->
          <template slot="no-body">
            <div class="mt-10">
              <vue-apex-charts
                type="radialBar"
                height="240"
                :options="analyticsData.goalOverviewRadialBar.chartOptions"
                :series="calculaTaxadeCrescimento()"
              />
            </div>
          </template>

          <!-- DATA -->
          <div class="flex justify-between text-center" slot="no-body-bottom">
            <div
              class="w-1/3 border border-solid d-theme-border-grey-light border-r-0 border-b-0 border-l-0"
            >
              <p class="mt-4">Crescimento</p>
              <p class="mb-4 text-3xl font-semibold">
                {{ getCrescimentoAssociados() }}
              </p>
            </div>
            <div
              class="w-1/3 border border-solid d-theme-border-grey-light border-r-0 border-b-0"
            >
              <p class="mt-4">Qtd Inicial</p>
              <p class="mb-4 text-3xl font-semibold">
                {{ getAssociadosInicial() }}
              </p>
            </div>
            <div
              class="w-1/3 border border-solid d-theme-border-grey-light border-r-0 border-b-0"
            >
              <p class="mt-4">Qtd Final</p>
              <p class="mb-4 text-3xl font-semibold">
                {{ getAssociadosFinal() }}
              </p>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full md:w-2/3 mb-base">
        <vs-card v-if="carregado == true">
          <h3>
            Veiculos {{ formataData2(this.objSend.dataInicial) }} -
            {{ formataData2(this.objSend.dataFinal) }}
          </h3>
          <vue-apex-charts
            type="area"
            height="350"
            :options="lineAreaChartSpline2.chartOptions"
            :series="lineAreaChartSpline2.series"
          ></vue-apex-charts>
        </vs-card>
      </div>
      <div class="vx-col w-full md:w-1/3 mb-base">
        <vx-card title="Taxa de Crescimento Veiculos">
          <template slot="actions">
            <feather-icon
              icon="HelpCircleIcon"
              svgClasses="w-6 h-6 text-grey"
            ></feather-icon>
          </template>

          <!-- CHART -->
          <template slot="no-body">
            <div class="mt-10">
              <vue-apex-charts
                type="radialBar"
                height="240"
                :options="analyticsData.goalOverviewRadialBar.chartOptions"
                :series="calculaTaxadeCrescimentoVeiculos()"
              />
            </div>
          </template>

          <!-- DATA -->
          <div class="flex justify-between text-center" slot="no-body-bottom">
            <div
              class="w-1/3 border border-solid d-theme-border-grey-light border-r-0 border-b-0 border-l-0"
            >
              <p class="mt-4">Crescimento</p>
              <p class="mb-4 text-3xl font-semibold">
                {{ getCrescimentoVeiculos() }}
              </p>
            </div>
            <div
              class="w-1/3 border border-solid d-theme-border-grey-light border-r-0 border-b-0"
            >
              <p class="mt-4">Qtd Inicial</p>
              <p class="mb-4 text-3xl font-semibold">
                {{ getVeiculosInicial() }}
              </p>
            </div>
            <div
              class="w-1/3 border border-solid d-theme-border-grey-light border-r-0 border-b-0"
            >
              <p class="mt-4">Qtd Final</p>
              <p class="mb-4 text-3xl font-semibold">
                {{ getVeiculosFinal() }}
              </p>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
import Filtro from './../../filtros/FiltroGraficoCrescimento';
import analyticsData from './../../../ui-elements/card/analyticsData.js';
import service from './../../../services';
import moment from 'moment';
export default {
  data() {
    return {
      realizaFiltro: false,
      filtro: null,
      objSend: {},
      analyticsData: analyticsData,
      carregado: false,
      themeColors: ['#7367F0', '#28C76F', '#FF9F43', '#EA5455', '#1E1E1E'],
      themeColors2: ['#EA5455', '#1E1E1E'],
      lineAreaChartSpline: {
        series: [
          {
            name: 'Inativos',
            data: [],
          },
          {
            name: 'Ativos',
            data: [],
          },
        ],
        chartOptions: {
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'smooth',
          },
          colors: this.themeColors,
          xaxis: {
            type: 'datetime',
            categories: [],
          },
          tooltip: {
            x: {
              format: 'dd/MM/yyyy',
            },
          },
        },
      },
      lineAreaChartSpline2: {
        series: [
          {
            name: 'Inativos',
            data: [],
          },
          {
            name: 'Ativos',
            data: [],
          },
        ],
        chartOptions: {
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'smooth',
          },
          colors: this.themeColors2,
          xaxis: {
            type: 'datetime',
            categories: [],
          },
          tooltip: {
            x: {
              format: 'dd/MM/yyyy',
            },
          },
        },
      },
    };
  },
  methods: {
    getAssociadosInicial() {
      return this.lineAreaChartSpline.series[1].data[0];
    },
    getAssociadosFinal() {
      var qtdArr = this.lineAreaChartSpline.series[1].data.length;
      return this.lineAreaChartSpline.series[1].data[qtdArr - 1];
    },
    getCrescimentoAssociados() {
      var tot = 0;
      var qtdArr = this.lineAreaChartSpline.series[1].data.length;
      tot =
        this.lineAreaChartSpline.series[1].data[qtdArr - 1] -
        this.lineAreaChartSpline.series[1].data[0];
      return tot;
    },
    calculaTaxadeCrescimento() {
      var tot = 0;
      var qtdArr = this.lineAreaChartSpline.series[1].data.length;
      tot =
        this.lineAreaChartSpline.series[1].data[qtdArr - 1] -
        this.lineAreaChartSpline.series[1].data[0];

      var total = (tot * 100) / this.lineAreaChartSpline.series[1].data[0];
      return [total.toFixed(1)];
    },
    getVeiculosInicial() {
      return this.lineAreaChartSpline2.series[1].data[0];
    },
    getVeiculosFinal() {
      var qtdArr = this.lineAreaChartSpline2.series[1].data.length;
      return this.lineAreaChartSpline2.series[1].data[qtdArr - 1];
    },
    getCrescimentoVeiculos() {
      var tot = 0;
      var qtdArr = this.lineAreaChartSpline2.series[1].data.length;
      tot =
        this.lineAreaChartSpline2.series[1].data[qtdArr - 1] -
        this.lineAreaChartSpline2.series[1].data[0];
      return tot;
    },
    calculaTaxadeCrescimentoVeiculos() {
      var tot = 0;
      var qtdArr = this.lineAreaChartSpline2.series[1].data.length;
      tot =
        this.lineAreaChartSpline2.series[1].data[qtdArr - 1] -
        this.lineAreaChartSpline2.series[1].data[0];

      var total = (tot * 100) / this.lineAreaChartSpline2.series[1].data[0];
      return [total.toFixed(1)];
    },
    filtraGeral() {
      this.preparaFiltro();
      this.buscaDadosCrescimento();
    },
    makeFiltro(filtro) {
      this.filtro = filtro;
      this.filtraGeral();
    },
    dataInicio() {
      return primeiroDia;
    },
    preparaFiltro() {
      this.objSend = {};
      if (this.filtro) {
        this.objSend = { ...this.filtro };
        this.objSend.dataInicial = moment(this.filtro.dataInicial).format(
          'YYYY-MM-DD',
        );
        this.objSend.dataFinal = moment(this.filtro.dataFinal).format(
          'YYYY-MM-DD',
        );
      } else {
        var date = new Date();
        var primeiroDia = new Date(date.getFullYear(), date.getMonth(), 1);
        var ultimoDia = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        this.objSend.dataInicial = moment(primeiroDia).format('YYYY-MM-DD');
        this.objSend.dataFinal = moment(ultimoDia).format('YYYY-MM-DD');
      }
    },
    formataData2(data) {
      return moment(data).format('DD/MM/YYYY');
    },
    finalizaFiltro() {
      this.realizaFiltro = false;
    },
    buscaDadosCrescimento() {
      this.carregado = false;
      this.$vs.loading();
      var objSend = { ...this.objSend };
      var arrDatas = [];
      var aA = [];
      var aI = [];
      var vA = [];
      var vI = [];
      objSend.tipo = 'crescimento';
      service.post('Relatorios', 'crescimento', objSend).then((res) => {
        res.data.forEach((element) => {
          aA.push(element.associadosAtivos);
          aI.push(element.associadosInativos);

          vA.push(element.veiculosAtivos);
          vI.push(element.veiculosInativos);

          var data = element.data;
          arrDatas.push(data);
        });

        this.lineAreaChartSpline.series[1].data = aA;
        this.lineAreaChartSpline.series[0].data = aI;
        this.lineAreaChartSpline2.series[1].data = vA;
        this.lineAreaChartSpline2.series[0].data = vI;
        this.lineAreaChartSpline.chartOptions.xaxis.categories = arrDatas;
        this.lineAreaChartSpline2.chartOptions.xaxis.categories = arrDatas;
        this.carregado = true;
        this.$vs.loading.close();
      });
    },
  },
  mounted() {
    this.filtraGeral();
    //this.$refs.chatLogPS.$el.scrollTop = this.$refs.chatLog.scrollHeight;
  },
  components: {
    Filtro,
    VueApexCharts,
  },
};
</script>
